export default "__VITE_ASSET__ae131f1e__"